import { Link } from 'react-router-dom';
import './Authors.css';

const AuthorsList = ({ authors = [], news = [], announcements = [], loading = false }) => {

  const getArticlesCount = (authorId, nickname) => {
    const items = [...news, ...announcements];
    return items.filter(item => item.authorId === authorId || item.author === nickname).length;
  };

  if (loading) {
    return <div className="loading">Ładowanie autorów...</div>;
  }

  return (
    <div className="authors-list-container">
      <div className="authors-list-wrapper">
        <h1 className="authors-list-title">Autorzy</h1>
        <p className="authors-list-desc">Poznaj wszystkich autorów i przejdź do ich profili.</p>
        <div className="authors-grid">
          {authors.map((a) => (
            <Link key={a.id} to={`/profiles/${a.nickname}`} className="author-card">
              <img
                src={`/images/${a.profilePic}`}
                alt={a.nickname}
                className="author-avatar"
                onError={(e) => {
                  // Ustaw prosty placeholder SVG gdy brak obrazka w public/images
                  e.target.src = 'data:image/svg+xml;utf8,' +
                    '<svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128 128">' +
                      '<rect width="128" height="128" fill="%23f0f0f0"/>' +
                      '<circle cx="64" cy="48" r="24" fill="%23c0c0c0"/>' +
                      '<rect x="24" y="84" width="80" height="28" rx="14" fill="%23d0d0d0"/>' +
                    '</svg>';
                }}
              />
              <div className="author-card-info">
                <div className="author-card-name">{a.nickname}</div>
                {/* {a.bio && (
                  <div className="author-card-bio">
                    {a.bio.length > 120 ? a.bio.slice(0, 120) + '…' : a.bio}
                  </div>
                )} */}
                {a.specialties && a.specialties.length > 0 && (
                  <div className="author-card-specialties">
                    {a.specialties.slice(0, 2).map((s, idx) => (
                      <span key={idx} className="author-specialty-tag">{s}</span>
                    ))}
                  </div>
                )}
                <div className="author-card-meta">
                  {getArticlesCount(a.id, a.nickname)} publikacji • od {a.joinDate ? new Date(a.joinDate).getFullYear() : '2024'}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AuthorsList;
